import React from "react";
import { withNavBars } from "../../HOCs";
import { withTranslation } from 'react-i18next';

class CommercialViewPageParent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
    }
  }
  render() {
    return <></>;
  }
}

const props = {
  key: 1
}

export default withNavBars(withTranslation('commercial')(CommercialViewPageParent), props);
